'use client'
import Field from './FormBlock.Field.client'
import styles from './FormBlock.module.scss'

export default function ReferAFriendFormFields() {
  return (
    <>
      <Field
        required
        label={'First name'}
        input={
          <input
            name={'First_Name'}
            type={'text'}
            placeholder={'First name'}
            required
            autoComplete={'off'}
          />
        }
        className={styles.half}
      />
      <Field
        label={'Last name'}
        input={<input name={'Last_Name'} type={'text'} placeholder={'Last name'} />}
        className={styles.half}
      />
      <Field
        required
        label={'Email address'}
        input={<input name={'Email'} type={'email'} placeholder={'Email address'} />}
        className={styles.half}
      />
      <Field
        label={'Mobile phone'}
        input={
          <input
            name={'Mobile_Phone'}
            type={'phone'}
            placeholder={'Mobile phone'}
            pattern="(0)(4|5)[0-9]{8}"
            minLength={10}
            maxLength={10}
          />
        }
        className={styles.half}
      />
      <Field
        required
        label={'Referral’s first name'}
        input={<input name={'referree_first_name'} type={'text'} placeholder={'First name'} />}
        className={styles.half}
      />
      <Field
        label={'Referral’s last name'}
        input={<input name={'referree_last_name'} type={'text'} placeholder={'Last name'} />}
        className={styles.half}
      />
      <Field
        required
        label={'Referral’s email address'}
        input={<input name={'referree_email'} type={'email'} placeholder={'Email address'} />}
        className={styles.half}
      />
      <Field
        label={'Referral’s mobile phone'}
        input={
          <input
            name={'referree_mobile_phone'}
            type={'phone'}
            placeholder={'Mobile phone'}
            pattern="(0)(4|5)[0-9]{8}"
            minLength={10}
            maxLength={10}
          />
        }
        className={styles.half}
      />
      <input type={'hidden'} name={'referrer_gift_type'} value={'giftcard'} />
      <input type={'hidden'} name={'referrer_donation_entity'} value={''} />
    </>
  )
}
